function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_187_840)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.0784 4.45848C16.6828 4.0627 16.2131 3.74874 15.6962 3.53454C15.1792 3.32033 14.6251 3.21008 14.0655 3.21008C13.5059 3.21008 12.9518 3.32033 12.4349 3.53454C11.9179 3.74874 11.4482 4.0627 11.0526 4.45848L10.2316 5.27948L9.41062 4.45848C8.61155 3.65941 7.52778 3.2105 6.39772 3.2105C5.26767 3.2105 4.18389 3.65941 3.38482 4.45848C2.58575 5.25755 2.13684 6.34132 2.13684 7.47138C2.13684 8.60144 2.58575 9.68521 3.38482 10.4843L4.20582 11.3053L10.2316 17.3311L16.2574 11.3053L17.0784 10.4843C17.4742 10.0887 17.7881 9.61899 18.0024 9.10203C18.2166 8.58506 18.3268 8.03096 18.3268 7.47138C18.3268 6.9118 18.2166 6.35769 18.0024 5.84073C17.7881 5.32377 17.4742 4.85407 17.0784 4.45848Z",
  stroke: "#808080",
  strokeWidth: 1.54905,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_187_840"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18.5886,
  height: 18.5886,
  fill: "white",
  transform: "translate(0.937256 0.888)"
})));
const SvgIconHeart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHeart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconHeart.d94dbdf9.svg";
export { ForwardRef as ReactComponent };